import { cx } from "cva";
import { useState } from "react";
import { useAnalytics } from "~/components/Analytics/useAnalytics";
import { ReportHorizontalEvent } from "~/components/ReportLibraryHorizontalPage/reportLibraryHorizontalEvents";
import { Headline } from "~/ui-library";

type Tab = {
  label: string;
  component: JSX.Element;
};

export type ReportLibraryHorizontalTabbedContainerProps = {
  tabs: Tab[];
};

export const ReportLibraryHorizontalTabbedContainer: React.FC<
  ReportLibraryHorizontalTabbedContainerProps
> = ({ tabs }) => {
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  const { analyticsEnhancedTrack } = useAnalytics();

  const handleTabClick = (index: number) => {
    if (index !== selectedTabIndex && tabs[index].label) {
      analyticsEnhancedTrack(ReportHorizontalEvent.ScheduleTabClicked, {
        tabName: tabs[index].label,
      });
      setSelectedTabIndex(index);
    }
  };

  return (
    <div>
      <div className="flex">
        {tabs.map((tab, index) => (
          <Headline
            as={tabs.length > 1 ? "button" : "div"}
            level={6}
            blockCase={true}
            key={index}
            className={cx(
              "mr-s pb-xs",
              selectedTabIndex === index
                ? "border-primary"
                : "border-transparent text-gray-700",
              tabs.length > 1 ? "border-b-2" : ""
            )}
            onClick={() => handleTabClick(index)}
          >
            {tab.label}
          </Headline>
        ))}
      </div>
      <div>{tabs[selectedTabIndex].component}</div>
    </div>
  );
};
